import { Injectable, OnInit } from "@angular/core";
import { SceneService } from "../scene/scene.service";
import { Observable, BehaviorSubject } from "rxjs";
import { MenuEnum } from "../../models/menus/MenuEnum";
import { MenuGeneric } from "src/app/models/menus/MenuGeneric";

//TODO: QUEDO DEPRECADO
@Injectable({
  providedIn: "root",
})
export class MenuServiceService {
  private menuButtons = [];
  public currentButtonClickedObservable = new BehaviorSubject<MenuGeneric>(
    null
  );
  constructor(private sceneService: SceneService) {
    //this.menuButtonsObservable.next(this.menuButtons);
  }

  public subMenuOpend(item: MenuGeneric) {
    this.currentButtonClickedObservable.next(item);
  }
}
